














































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import OrganizationModel from "@/model/Organization";
import OrganizationApi from "@/api/Organization";
import ModelFactory from "@/model/ModelFactory";
import BaseInput from "@/components/Base/Controls/BaseInput.vue";
import OrganizationEdit from "./OrganizationEdit.vue";
import { namespace } from "vuex-class";
import ReportModel from "@/model/Report";
import ReportAdmin from "@/components/Report/ReportAdmin.vue";

const AppStore = namespace("App");
const UserStore = namespace("User");
const FormStore = namespace("Form");

@Component({
  name: "Organization",
  components: {
    BaseInput,
    OrganizationEdit,
    ReportAdmin
  }
})
export default class Organization extends Vue {
  @Prop()
  readonly disabled!: boolean;

  @Prop()
  readonly value!: OrganizationModel[];

  public organizations: OrganizationModel[] = [];
  public organization: OrganizationModel | null = null;
  public selectedOrganization: string | number = "";
  public filter: string = "";
  public report: ReportModel = ModelFactory.create("ReportModel");
  public showEditDialog: boolean = false;

  // @AppStore.State
  // public isReportSent!: boolean;

  @AppStore.State
  public reportYear!: number;

  @AppStore.State
  public canPublishReport!: boolean;

  // @AppStore.State
  // public organizations!: object;

  @UserStore.Getter
  public isAdmin!: boolean;

  @UserStore.Getter
  public getOrganization!: string;

  @FormStore.State
  public formDisabled!: boolean;

  created() {
    this.organizations = this.value;
  }

  @Watch("value")
  setOrganizations(organizations: OrganizationModel[]) {
    this.organizations = organizations;
  }

  get total() {
    let amount = 0;
    this.organizationsFiltered.forEach(
      (item: OrganizationModel): number => (amount += item.amount)
    );

    return amount;
  }

  get organizationsFiltered() {
    const filterFunction = (item: OrganizationModel) => {
      const regex = new RegExp(`${this.filter}`, "i");
      return (
        item.name.match(regex) ||
        item.description.match(regex) ||
        item.amount.toString().match(regex)
      );
    };

    const sortFunction = (
      item1: OrganizationModel,
      item2: OrganizationModel
    ) => {
      const name1 = item1.name.toLowerCase();
      const name2 = item2.name.toLowerCase();
      return name1 > name2 ? 1 : name1 < name2 ? -1 : 0;
    };

    return this.organizations.filter(filterFunction).sort(sortFunction);
  }

  search(e: string): void {
    this.filter = e;
  }

  newOrganization(): void {
    this.organization = ModelFactory.create("OrganizationModel");
    this.showEditDialog = true;
  }

  editOrganization(organizationId: number): void {
    const selectedOrganization = this.organizations.filter(
      (item: OrganizationModel) => {
        return item.id === organizationId;
      }
    );
    this.organization = ModelFactory.create(
      "OrganizationModel",
      selectedOrganization[0]
    );
    this.showEditDialog = true;
  }

  removeOrganization(organizationId: number): void {
    const organization = this.getById(organizationId);

    if (organization) {
      this.$bvModal
        .msgBoxConfirm(`Usunąć ${organization.name}?`, {
          okVariant: "danger",
          okTitle: "Tak",
          cancelTitle: "Nie"
        })
        .then((ok: boolean) => {
          if (ok) {
            OrganizationApi.remove(organization.id as number).then(() => {
              this.organizations = this.organizations.filter(
                (item: OrganizationModel) => {
                  return item.id !== organizationId;
                }
              );
            });
          }
        });
    }
  }

  getById(organizationId: number): OrganizationModel | null {
    const organization = this.organizations.filter(
      (item: OrganizationModel) => {
        return item.id === organizationId;
      }
    );
    return organization.length ? organization[0] : null;
  }

  closeEdit(): void {
    this.organization = ModelFactory.create("OrganizationModel");
    this.showEditDialog = false;
  }

  saveEdit(organization: OrganizationModel): void {
    if (this.organization && !this.organization.id) {
      this.organizations.push(
        ModelFactory.create("OrganizationModel", organization)
      );
    } else {
      this.organizations.forEach(item => {
        if (item.id === this.organization?.id) {
          item = Object.assign(item, organization);
        }
      });
    }
    this.organization = ModelFactory.create("OrganizationModel");
    this.showEditDialog = false;
  }
}
